import { render, staticRenderFns } from "./OrganizationGroupField.vue?vue&type=template&id=0eb10da6"
import script from "./OrganizationGroupField.vue?vue&type=script&lang=js"
export * from "./OrganizationGroupField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports